<form id="share-certificates-form" #sharedCertForm="ngForm" class="bl-font-color--base">
  <div class="flexbox-format" *ngFor="let item of beneficiaryList;let i = index;">
    <div class="bl-margin-bottom--16 inline">
      <label for="type-{{i}}" class="bl-label bl-required bl-font-weight--800 bl-font-size--14">Beneficiary
        {{item.acutalIndex+1}} - {{item.type.value}}</label>
      <input #allocation="ngModel" [(ngModel)]="item.allocation.value" id="allocation-{{i}}" class="bl-input"
        name="allocation-{{i}}" required (blur)="focused = false; processMask($event,item.allocation,false)"
        (focus)="focused = true; processMask($event,item.allocation);" (cut)="processMask($event,item.allocation)"
        (paste)="processMask($event,item.allocation)" (input)="processMask($event,item.allocation)"
        (keyup)="processMask($event,item.allocation)" (mouseup)="processMask($event,item.allocation)"
        (change)="onChange($event,item.allocation,item.acutalIndex)" aria-errormessage="error-beneficiary" />
      <cu-validation-messages fieldId="beneficiary" fieldLabel="Beneficiary" *ngIf="allocation.invalid && allocation.dirty" [failedValidations]="validation">
      </cu-validation-messages>
    </div>
  </div>
  <div *ngIf="beneficiaryList && beneficiaryList.length > 0&&totalAllocation ">
    <label class="bl-label bl-font-weight--800 bl-font-size--14">Total {{beneficiaryList[0].type.value}} Allocation:</label>
    <div>{{totalAllocation? totalAllocation+"%":''}}</div>

  </div>
  <div class="bl-error-msg bl-margin-top--16 bl-font-size--16" *ngIf="totalAllocation&&allocationLeft > 0">
    <label class="bl-label bl-font-weight--800">% left to allocate:</label>
    <div>{{allocationLeft}} %</div>
  </div>
  <div class="bl-error-msg bl-margin-top--16 bl-font-size--16" *ngIf="totalAllocation&&allocationMore > 0">
    <label class="bl-label bl-font-weight--800">% over allocation:</label>
    <div>{{allocationMore}} %</div>
  </div>

</form>
